import React from 'react';
import ImageGallery from 'react-image-gallery';
// import { Carousel } from 'react-responsive-carousel';
import { Footer, Possibility, FindPlace, PopularPlace } from '../../containers/index';
import { Navbar } from '../../components';
// import possibilityImage from '../../assets/place3.jpeg';
// import slider1 from '../../assets/place1.jpg';
// import slider2 from '../../assets/place4.jpeg';
import 'react-image-gallery/styles/css/image-gallery.css';
import '../../App.css';

const images = [
  {
    original: 'https://i.pinimg.com/originals/b9/a7/d1/b9a7d15aaae18649ccfc03af49c54cd7.jpg',
    thumbnail: 'https://picsum.photos/id/1018/250/150/',
    originalWidth: '100%',
    description: '(identified by the partial demolition tag in the folder description). The intent is to answer a question raised about the ratio of partial to total demolitions.',
  },
  {
    originalWidth: '100%',
    original: 'https://picsum.photos/id/1015/1000/600/',
    thumbnail: 'https://picsum.photos/id/1015/250/150/',
  },
  {
    original: 'https://picsum.photos/id/1019/1000/600/',
    thumbnail: 'https://picsum.photos/id/1019/250/150/',
  },
];

const Index = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
      <ImageGallery items={images} />
    </div>
    <div className="gpt3__possibility section__padding" id="possibility">
      {/* <div className="gpt3__possibility-image">
      </div> */}
      {/* <div className="gpt3__possibility-content">
        Hello
      </div> */}
    </div>
    <Possibility />
    <FindPlace />
    <PopularPlace />
    <Footer />
  </div>
);

export default Index;
